// import { useState } from "react";

const Energy = ({ energyColor }) => {
	const scale = 0.8;
	const boxDim = 1 * scale;

	// const [ energyColor, setEnergyColor ] = useState(matColor);

	return (
		<mesh
			visible
			userData={{ hello: 'world' }}
			position={[0, 7, 12.75]}
			rotation={[0, 0, 0]}
		>
			<boxGeometry args={[boxDim, boxDim, boxDim]} />
			<meshBasicMaterial color={energyColor} />
		</mesh>
	);
};

export default Energy;
